import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {MeetingTitleDialogComponent} from '../meeting-title-dialog/meeting-title-dialog.component';

@Component({
  selector: 'app-past-meetings-list',
  templateUrl: './past-meetings-list.component.html',
  styleUrls: ['./past-meetings-list.component.css']
})
export class PastMeetingsListComponent implements OnInit {

  options: any
  today : any
  currentDate : any

  @Input() deviceXs: any;
  @Input() deviceLg: any;
  @Input() deviceMd: any;
  @Input() deviceXl: any;

  xl = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "30%"
    },
    width : "calc(100% - 100px)",
    height : "calc(100% - 0px)",
  }

  lg = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "30%"
    },
    width : "calc(100% - 100px)",
    height : "calc(100% - 0px)",
  }

  md = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "30%"
    },
    width : "calc(100% - 100px)",
    height : "calc(100% - 0px)",
  }

  sm = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "20%"
    },
    width : "calc(100% - 100px)",
    height : "calc(100% - 0px)",
  }

  xs = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "20%"
    },
    width : "calc(100% - 0px)",
    height : "calc(100% - 0px)",
  }

  constructor(private dialog : MatDialog) { }

  openMeetingTitleDialog() {
    // this.dialog.open(MeetingTitleDialogComponent, {
    //   panelClass: ['animate__animated','animate__slideInRight'],
    //   position : {
    //     left : "50%"
    //   },
    //   width : "700px",
    //   height : "700px",
    // })
    if(this.deviceLg){
      this.dialog.open(MeetingTitleDialogComponent, this.lg)
    }
    if(this.deviceMd){
      this.dialog.open(MeetingTitleDialogComponent, this.md)
    }
    if(this.deviceXs){
      this.dialog.open(MeetingTitleDialogComponent, this.xs)
    }
    if(this.deviceXl){
      this.dialog.open(MeetingTitleDialogComponent, this.xl)
    }
  }

  ngOnInit(): void {
    this.options = {
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }
  
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US",this.options)
  }

}
